import { appNames } from '@dvag/dfs-constant-config/app-names';

export const dashboardUtil = {
  HHB_AND_CONTRACT_OVERVIEW: 'hhb-und-vertragsuebersicht',
  INTERVIEW_CONCLUSION: 'interview-conclusion',
  PERSONAL_DATA: 'persoenliche-daten',
  PERSON: appNames.person,
  ADVISOR: appNames.advisor,
  ACCOUNTING: appNames.accounting,
  VPD: appNames.vpd,
  SHOPPING_CART: appNames.shoppingCart,
  ENVPROD: 'prod',
  ENVUAT: 'uat',
  PRIVACY_POLICY: 'datenschutzbestimmungen',
  CUSTOMER_ACCESS: 'kundenzugang',
  RECOMMENDATION: 'kundenwerbenkunden',
  RECOMMENDATION_PRESENTATION: 'kunden-werben-kunden-praesentation',
  RECOMMENDATION_DIRECT_ACCESS: 'kunden-werben-kunden-direkteinstieg',
  DREAM_JOB: 'berufmitzukunft',
  DIRECT_ACCESS: 'direkteinstieg',
  PERSENTATION: 'presentation',
  ANALYSIS_EVALUATION: appNames.analysisEvaluation,
  COACH_REPORT: appNames.supervisorReport,
  PENSION_RENTING: 'rente-und-wohnen',
  HOUSEHOLD_BUDGET_AND_CONTRACT: 'household-budget-and-contract',
  PENSION_AND_HOUSING: 'pension-and-housing',
  CONVERSATION_SUMMARY: 'gespraechszusammenfassung',
  GOLDRICHTIGE_EMPFEHLUNG: 'goldrichtige-empfehlung',
  TRAUMBERUF: 'traumberuf',
  TRAUMBERUF_PRESENTATION: 'traumberuf-praesentation',
  TRAUMBERUF_DIRECT_ACCESS: 'traumberuf-direkteinstieg',
};
